import "./App.css";
import {
	createHashRouter,
	NavLink,
	RouterProvider,
} from "react-router-dom";
import { Home } from "./pages/Home";
import { Footer, Root } from "./pages/Root";
import {About} from "./pages/About";
import {District} from "./pages/District";
import {Issues} from "./pages/Issues";
import {Contact} from "./pages/Contact";
import {Information} from "./components/Information";

const router = createHashRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: (
      <div className={""}>
        Page Not Found
        <NavLink className={"text-blue-600"} to={"/"}>
          Go Back Home
        </NavLink>
      </div>
    ),
    children: [
      {
        path: "",
        element: <Home />,
      },
      {
        path: "issues",
        element: <Issues />,
      },
      {
        path: "district",
        element: <District />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
    ],
  },
]);

function App() {
	return (
    <>
      <RouterProvider router={router} />
      {/*<Information />*/}
    </>
  );
}

export default App;
